import React from 'react';
import styled from 'fe-styled-components';
import axios from 'fe-axios';
import theme from 'fe-appdir-lib-theme';
import { env } from 'fe-lib-env';

const getFooterApiUrl = (env) => {
  let url;
  const queryParamBase = `?is-appdir=1`;

  // Create unique URLs for each environment to ensure correct CORS headers set (correct headers set in Craft Wrapper)
  switch (env) {
    case 'production': // We don't have a "staging" environment because the env vars are embedded on build
      // Production URL
      url = `https://hootsuite.com/craft/api/wrapper${queryParamBase}&is-prod=1`; // Real production
    
      // Prerendering
      if (navigator.userAgent === 'ReactSnap') {
        url = `https://hootsuite.com/craft/api/wrapper${queryParamBase}&is-prerendering=1`;
      } 

      // Staging
      if (/staging/.test(window.location.hostname)) { // Check hostname for staging
        url = `https://staging.hootsuite.com/craft/api/wrapper${queryParamBase}&is-staging=1`; 
      }
      break;
    default: 
      // If not prod, we're in dev - no need for varying here as there is no cache
      url = 'http://dev.craft.hootsuite.com/craft/api/wrapper';
  }

  return url;
};

const Container = styled.div`
  font-family: ${theme.fontFamilyPrimary};
`;

class Footer extends React.Component {
  state = {
    footerSource: null,
  };

  componentDidMount() {
    axios.get(getFooterApiUrl(env())).then(
      (response) => {
        this.setState({
          footerSource: `${response.data.footer}${response.data.assets}`,
        });
      },
      (error) => {
        /* eslint-disable-next-line no-console */
        console.warn('Call to website-craft footer API failed.', error);
      },
    );
  }

  render() {
    return (
      this.state.footerSource && (
        <Container
          dangerouslySetInnerHTML={{ __html: this.state.footerSource }}
        />
      )
    );
  }
}

Footer.displayName = 'Footer';

export default Footer;
